export type PendingActionType =
  | "policy"
  | "user"
  | "transaction"
  | "group"
  | "vote"
  | "account_setup"
  | "helper";

export type PendingActionStatus = "pending" | "synced" | "expired";

export interface PendingActionSummary {
  // Common
  description?: string;
  // Transaction
  amount?: string;
  asset?: string;
  recipientAddress?: string;
  // Policy
  policyName?: string;
  policyType?: string;
  // User
  userName?: string;
  userAddress?: string;
  // Group
  groupName?: string;
  // Vote
  voteChoice?: "YES" | "NO";
  targetActionSignature?: string; // The signature of the action being voted on
  targetActionType?: string; // The type/class of the action being voted on
  // Account Setup
  accountName?: string;
  includesSafe?: boolean;
  // Helper
  helperName?: string;
  helperAddress?: string;
  helperAction?: "add" | "remove" | "update";
}

export interface PendingAction {
  id: string;
  signature: string;
  groupSignature?: string; // For batch operations - all items in the batch share this signature
  actionType: PendingActionType;
  summary: PendingActionSummary;
  timestamp: number;
  destinationAddress: string;
  parentGroup: string;
  status: PendingActionStatus;
  isDeleted?: boolean;
}

export const PENDING_ACTIONS_STORAGE_KEY = "wikey_pending_actions";

// Expiry times by action type
export const PENDING_ACTION_EXPIRY_MS = 2 * 60 * 1000; // 2 minutes (default)
export const ACCOUNT_SETUP_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes (safe creation)

// Helper function to get expiry time by action type
export const getExpiryForActionType = (type: PendingActionType): number => {
  return type === "account_setup" ? ACCOUNT_SETUP_EXPIRY_MS : PENDING_ACTION_EXPIRY_MS;
};
